import { addCoreSelectionsSyncSlice } from './add';
import { removeCoreSelectionsSyncSlice } from './remove';

export const { syncActionCreator: addCoreSelections } = addCoreSelectionsSyncSlice;
export const { syncActionCreator: removeCoreSelections } = removeCoreSelectionsSyncSlice;
